module.exports = __webpack_public_path__ + "img/vertical_3_6_8003.f5106c54.png";